
import UserInfo from "../components/UserInfo.vue";
import { defineComponent, onBeforeMount } from "vue";
import { useUser } from "../hooks/useUserInfo";
import router from "@/router";
import { useLocalStorage } from "@/hooks/useLocalStorage";
import { UserTypes } from "@/static/UserTypes";

export default defineComponent({
  components: {
    UserInfo,
  },
  setup() {
    const { userData, getUserData } = useUser();
    const { storedValue } = useLocalStorage("userType");
    onBeforeMount(() => {
      if (storedValue.value === UserTypes.Customer) {
        getUserData(2);
      } else {
        getUserData(3);
      }
    });
    const onLogout = () => {
      localStorage.removeItem("token");
      localStorage.removeItem("userType");

      router.push("/login");
    };
    return { userData, onLogout };
  },
});
